"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = require("react");
var _ = require("..");

/**
 * Effect that runs only on deps change, ignoring first render
 */
function useUpdateEffect(cb, deps) {
  var isFirstRender = (0, _.useIsFirstRender)();
  (0, _react.useEffect)(function () {
    if (!isFirstRender) {
      return cb();
    }
  }, deps);
}
var _default = useUpdateEffect;
exports["default"] = _default;